<!-- PARÁMETROS DE LIQUIDACIÓN EN UNA SOLA OPCIÓN (Mario, 12-oct; PAR-02): las opciones agrupadas; cada una, en su pantalla. -->
<div class="kb-page">
  <nav class="kb-migas" aria-label="Migas">
    <a class="kb-miga" routerLink="/console/parametros-sistema">Parámetros del sistema</a>
    <i class="fas fa-chevron-right kb-miga-sep" aria-hidden="true"></i>
    <span class="kb-miga-actual">Liquidación a comercios</span>
  </nav>

  <div class="kb-page-header">
    <div class="max-w-[720px]">
      <h1 class="kb-page-title flex items-center gap-2.5"><i class="fas fa-hand-holding-usd text-[0.85em] text-muted-foreground" aria-hidden="true"></i>Liquidación a comercios</h1>
      <p class="kb-page-meta">Todo lo que se configura para liquidar y pagar a los comercios. Cada opción se administra por separado, con su permiso.</p>
    </div>
  </div>

  <ng-container *ngFor="let g of grupos">
    <section class="flex flex-col gap-3" *ngIf="visibles(g).length">
      <div>
        <h2 class="m-0 text-xs font-semibold uppercase tracking-wider text-muted-foreground">{{ g.titulo }}</h2>
        <p class="kb-dato-nota m-0">{{ g.descripcion }}</p>
      </div>
      <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
        <a *ngFor="let o of visibles(g)" [routerLink]="o.route"
           class="kb-card flex items-center gap-4 !p-4 no-underline transition-all hover:border-foreground/40 hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-ring">
          <span class="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg" [ngClass]="o.color"><i [class]="o.icon + ' text-xl'" aria-hidden="true"></i></span>
          <span class="min-w-0 flex-1">
            <span class="block text-base font-semibold text-foreground">{{ o.title }}</span>
            <span class="block text-sm text-muted-foreground">{{ o.description }}</span>
          </span>
          <i class="fas fa-chevron-right shrink-0 !text-muted-foreground" aria-hidden="true"></i>
        </a>
      </div>
    </section>
  </ng-container>
</div>
